import {Address} from "@services/types";

export const getGoogleMapsDirections = (
  {firstLine, city, state, zip}: Address,
  googlePlaceId?: string,
) => {
  const destination = [firstLine, city, state, zip].join(" ");
  const destinationPlaceId = googlePlaceId ? `&destination_place_id=${googlePlaceId}` : "";
  const query = `destination=${destination}${destinationPlaceId}`;
  return `https://www.google.com/maps/dir/?api=1&${query}`;
};
